// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3tNV7","name":"ConsentHeader_name__2WPrD","birthday":"ConsentHeader_birthday__3wN0I","skeleton":"ConsentHeader_skeleton__Uwh4C"};